import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'
import {getLoginId} from '../../functions/Common.js'

// 获取服务器的朋友圈模板列表
export function webGetFriendCircleList(param,callback){
	param.manager_id = getLoginId()
	request({
			method: 'post',
			url: 'FriendCircle/getListWithPage',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}